/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getContractListAsync } from './DataActionExtension.g';
import { IContractListEntity } from './DataServiceEntities.g';

/**
 * GetContractList Input Action
 */

export class GetContractListInput implements Msdyn365.IActionInput {
    public accountNum: string;
    constructor(accountNum: string) {
        this.accountNum = accountNum;
    }

    public getCacheKey = () => 'ContractList';
    public getCacheObjectType = () => 'ContractList';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetContractListData {
    contractList: IContractListEntity[];
}

const createContractListInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    // Get the customer account number in order to find contracts associated with the current user.

    // @ts-expect-error
    const accountNum = args.requestContext.User.CustomerAccountNumber || '';
    return new GetContractListInput(accountNum);
};

async function action(input: GetContractListInput, ctx: Msdyn365.IActionContext): Promise<IGetContractListData> {
    const response = await getContractListAsync({ callerContext: ctx }, input.accountNum);
    return { contractList: response };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetContractListData>>action,
    id: 'GetContractList',
    input: createContractListInput
});
